<div class="scroll-hidden"><div class="login-headers"><span (click)="navigateToLaunch()" class="cursor d-flex"><span class="login-logo-1">UST</span> <span
            class="login-logo-2">iDEC</span></span></div>

<div class="make-responsive-login-graphics">
    <!-- <div class="flex-row login-page-logo justify-content-center cursor-pointer w-100">
<img src="../../assets/images/idecfaceappA.svg"
    class="w-50 cursor" alt="" (click)="loadLaunch()"/>
</div> -->
    <div class="right-bg-container">


        <div class="video-1 position-relative">
            <div class="foreground-graident"></div><video width="100%" height="100%" id="myVideo" class=""
                preload="auto" autoplay loop [muted]="'muted'">
                <source src="../../assets/images/video-1.mp4" type="video/mp4" />
            </video>
        </div>
        <div><video width="40%" height="auto" preload="auto" class="video-2" autoplay loop [muted]="'muted'">
                <source src="../../assets/images/figma-DigitalTwin_LoginAnimation.mp4" type="video/mp4" />
            </video></div>


    </div>
<div *ngIf="isSelected.isLogin" class="content-auth-wrapper bg-signup">
    <app-login  [tenantList]="tenantList"></app-login>
</div>
 <div *ngIf="isSelected.isForgotPassword" class="content-auth-wrapper bg-signup">
    <app-forgot-password [clientList]="tenantList">
    </app-forgot-password>
</div> 
 <div *ngIf="isSelected.isSignup" class="content-auth-wrapper bg-signup">
    <app-signup [tenantList]="tenantList"></app-signup>
</div> 
</div>
</div>